import { PollutantType, HealthAdviceTypes } from '../../components/airQuality/v2/types';

export const SELECT_AIR_QUALITY_POLLUTANT = 'SELECT_AIR_QUALITY_POLLUTANT';
export const SELECT_AIR_QUALITY_HEALTH_ADVICE = 'SELECT_AIR_QUALITY_HEALTH_ADVICE';
export const CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP = 'CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP';

export type CloseAqiPollutantHealthAdvicePopupActionType = {
    type: typeof CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP;
    payload?: unknown;
}

export type SelectPollutantActionType = {
    type: typeof SELECT_AIR_QUALITY_POLLUTANT;
    payload: {
        showPopup: boolean;
        pollutantType: keyof typeof PollutantType;
    };
}

export type SelectHealthAdviceActionType = {
    type: typeof SELECT_AIR_QUALITY_HEALTH_ADVICE;
    payload: {
        showPopup: boolean;
        healthAdviceType: keyof typeof HealthAdviceTypes;
    };
}

export function closeAqiPollutantHealthAdvicePopup(): CloseAqiPollutantHealthAdvicePopupActionType {
    return {
        type: CLOSE_AIR_QUALITY_POLLUTANT_HEALTH_ADVICE_POPUP
    };
}

export function selectPollutant(showPopup: boolean, pollutantType: keyof typeof PollutantType): SelectPollutantActionType {
    return {
        type: SELECT_AIR_QUALITY_POLLUTANT,
        payload: {
            showPopup,
            pollutantType
        }
    };
}

export function selectHealthAdvice(showPopup: boolean, healthAdviceType: keyof typeof HealthAdviceTypes): SelectHealthAdviceActionType {
    return {
        type: SELECT_AIR_QUALITY_HEALTH_ADVICE,
        payload: {
            showPopup,
            healthAdviceType
        }
    };
}
